import { render } from "./DsTask.vue?vue&type=template&id=04e7f3a6&scoped=true"
import script from "./DsTask.vue?vue&type=script&lang=js"
export * from "./DsTask.vue?vue&type=script&lang=js"

import "./DsTask.vue?vue&type=style&index=0&id=04e7f3a6&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e7f3a6"]])

export default __exports__